var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"containers"},[(_vm.doc !== '')?_c('div',{staticClass:"ql-editor",domProps:{"innerHTML":_vm._s(_vm.doc)}}):_c('div',{staticStyle:{"text-align":"center","padding":"20px"}},[_vm._v("\n    暂无新手指引，敬请期待。\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2dea0021","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/guide/index.vue
// module id = null
// module chunks = 